var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "Polaris-Page px-6",
      class: { "Polaris-Page--fullWidth": _vm.isFullWidth }
    },
    [
      _c(
        "div",
        {
          staticClass: "Polaris-Box",
          staticStyle: {
            "--pc-box-padding-block-end-xs": "var(--p-space-4)",
            "--pc-box-padding-block-end-md": "var(--p-space-5)",
            "--pc-box-padding-block-start-xs": "var(--p-space-4)",
            "--pc-box-padding-block-start-md": "var(--p-space-5)",
            "--pc-box-padding-inline-start-xs": "var(--p-space-4)",
            "--pc-box-padding-inline-start-sm": "var(--p-space-0)",
            "--pc-box-padding-inline-end-xs": "var(--p-space-4)",
            "--pc-box-padding-inline-end-sm": "var(--p-space-0)",
            position: "relative"
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "Polaris-Page-Header--noBreadcrumbs Polaris-Page-Header--mediumTitle"
            },
            [
              _c("div", { staticClass: "Polaris-Page-Header__Row" }, [
                _vm.showBack
                  ? _c(
                      "div",
                      { staticClass: "Polaris-Page-Header__BreadcrumbWrapper" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "Polaris-Box Polaris-Box--printHidden",
                            staticStyle: {
                              "--pc-box-max-width": "100%",
                              "--pc-box-padding-inline-end-xs":
                                "var(--p-space-4)"
                            }
                          },
                          [
                            _c("nav", { attrs: { role: "navigation" } }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "Polaris-Breadcrumbs__Breadcrumb",
                                  attrs: { "data-polaris-unstyled": "true" },
                                  on: { click: _vm.goBack }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "Polaris-Breadcrumbs__Icon"
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "Polaris-Icon" },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "Polaris-Text--root Polaris-Text--visuallyHidden"
                                          }),
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "Polaris-Icon__Svg",
                                              attrs: {
                                                viewBox: "0 0 20 20",
                                                focusable: "false",
                                                "aria-hidden": "true"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M17 9h-11.586l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3.293-3.293h11.586a1 1 0 1 0 0-2z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "Polaris-Page-Header__TitleWrapper" },
                  [
                    _c("h1", { staticClass: "Polaris-Header-Title" }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  ]
                ),
                _c("div", { staticClass: "Polaris-Page-Header__RightAlign" }, [
                  _c(
                    "div",
                    { staticClass: "Polaris-Page-Header__Actions" },
                    [_vm._t("action")],
                    2
                  )
                ])
              ])
            ]
          ),
          _c("div", [_vm._t("default")], 2)
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }